import { useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./Reports.css";
import { Context } from "../../context/Context";
import { Details } from "./details/Details";
import { Daily } from "./daily/Daily";
import { Monthly } from "./monthly/Monthly";
import { translations } from "../../utils/lang";
import { REPORT_VIEWS, getReportView } from "./reportViews";

// The active report comes from `?report=` (chosen in the sidebar); Faults is
// the default when none is given.
export const Reports = () => {
  const { lang } = useContext(Context);
  const [searchParams] = useSearchParams();
  const activeView = getReportView(searchParams);

  // Views stay mounted once opened, so switching back doesn't refetch the
  // whole dataset or reset that report's filters.
  const [visitedViews, setVisitedViews] = useState(() => new Set([activeView]));
  if (!visitedViews.has(activeView)) {
    setVisitedViews(new Set(visitedViews).add(activeView));
  }

  const content = {
    faults: <Details active={activeView === "faults"} />,
    daily: <Daily active={activeView === "daily"} />,
    monthly: <Monthly active={activeView === "monthly"} />,
  };

  return (
    <div className="reports">
      {REPORT_VIEWS.filter(({ key }) => visitedViews.has(key) || key === activeView).map(
        ({ key, labelIndex }) => (
          <section
            key={key}
            className="reports-content"
            aria-label={translations[lang].reports.header[labelIndex]}
            hidden={key !== activeView}
          >
            {content[key]}
          </section>
        ),
      )}
    </div>
  );
};
